<template>
  <div>
    <!-- <AuditorPage></AuditorPage> -->
    <ManufacturerPage></ManufacturerPage>
  </div>
</template>

<script>
import AuditorPage from './AuditorPage.vue'
import ManufacturerPage from './ManufacturerPage.vue'
export default {
  components: {
    AuditorPage,
    ManufacturerPage,
  },
  data() {
    return {
      type:null,
    }
  },
  created() {
    this.type = this.$store.getters.userInfo.type
    //  == "0"
  },
}
</script>

<style>
</style>